const youtubeVideo = () => { 
    $('#player').slick({
        centerMode: true,
        centerPadding: '190px',
        slidesToShow: 1,
        arrows: false,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    centerPadding: '70px',
                }
            },
            {
                breakpoint: 768,
                settings: {
                    centerPadding: '50px',
                }
            },
            {
                breakpoint: 480,
                settings: {
                    centerPadding: '30px',
                }
            }
        ]
    });

    $('.expense-manager-video__arrow--left__container').on('click', () => {
        $('#player').slick('slickPrev');
    })
        
    $('.expense-manager-video__arrow--right__container').on('click', () => {
        $('#player').slick('slickNext');
    })

};

const events = () => {
    youtubeVideo();
}

const init = () => {
    events();
}

export default init;

